








































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { KesadaranGCS } from "@/types";
import moment from "moment";
import ptiService from "@/services/TransferInternal";
import { PtiTransferResponseItem, PtiReceivedData } from "@/types/pti";
import storeReferensiUnit from "@/store/modules/new/ReferensiUnit";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storePerawat } from "@/store/modules/perawat";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import FrekuensiNafas from "@/components/pemeriksaan/assesmen/FrekuensiNafas.vue";
import SaturasiOksigen from "@/components/pemeriksaan/assesmen/SaturasiOksigen.vue";
import SuhuBadan from "@/components/pemeriksaan/assesmen/SuhuBadan.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarahNew.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { Tensi } from "@/types/asesmen";

@Component({
  components: {
    TekananDarah,
    FrekuensiNadi,
    FrekuensiNafas,
    SuhuBadan,
    SaturasiOksigen,
    VCDateTimePicker
  }
})
export default class PenerimaTransferInternal extends Vue {
  @Prop() readonly register!: number;
  @Prop({ default: false }) readonly open!: boolean;
  @Prop() readonly transferData!: any;
  @Prop({ default: "received" }) readonly mode!: string;
  @Prop() readonly value: KesadaranGCS;
  @Prop({
    default: ["sistole", "diastole", "nadi", "nafas", "suhu", "saturasiO2"]
  })
  params;
  @Prop({ type: Boolean, default: false }) readonly isReadonly!: boolean;
  @Prop({ type: Boolean, default: false }) readonly catatanOnly!: boolean;
  @Prop({ default: null }) readonly selectedId!: number;
  isLoading = false;
  currentTransferId: number | null = null;

  fromUnitId: string | null = null;
  toUnitId: string | null = null;
  receivedAt: string | Date | null = null;
  isAlreadyReceived = false;

  noKamar: string | null = null;
  kelasKamar: string | null = null;

  toUserId: number | null = null;
  userLoginId = Number(userModule.user.id);

  gcsEye: number | null = null;
  gcsVerbal: number | null = null;
  gcsMotor: number | null = null;
  kesadaran: string | null = null;
  djj: number | null = null;
  bbs: number | null = null;
  tb: number | null = null;
  bbl: number | null = null;
  downscore: number | null = null;
  note: string | null = null;
  sistole: number | null = null;
  diastole: number | null = null;
  nadi: number | null = null;
  nafas: number | null = null;
  suhu: number | null = null;
  saturasiO2: number | null = null;
  isLoadingReceived = false;
  formError: {
    receivedAt: string | null;
    eye: string | null;
    verbal: string | null;
    motor: string | null;
    tekananDarah: string | null;
    nadi: string | null;
    nafas: string | null;
    suhu: string | null;
    saturasiO2: string | null;
  } = {
    receivedAt: null,
    eye: null,
    verbal: null,
    motor: null,
    tekananDarah: null,
    nadi: null,
    nafas: null,
    suhu: null,
    saturasiO2: null
  };

  gcsEyeOptions = [
    { id: 1, name: "Tidak membuka mata" },
    { id: 2, name: "Dengan rangsangan nyeri" },
    { id: 3, name: "Dengan perintah suara" },
    { id: 4, name: "Spontan" },
    { id: 0, name: "NT" }
  ];
  gcsVerbalOptions = [
    { id: 1, name: "Tidak bersuara" },
    { id: 2, name: "Mengerang" },
    { id: 3, name: "Kata" },
    { id: 4, name: "Orientasi abnormal" },
    { id: 5, name: "Kalimat lengkap dan orientasi baik" },
    { id: 0, name: "NT" }
  ];
  gcsMotorOptions = [
    { id: 1, name: "Tidak bergerak" },
    { id: 2, name: "Response ekstensi abnormal" },
    { id: 3, name: "Response fleksi abnormal" },
    { id: 4, name: "Menjauhi nyeri" },
    { id: 5, name: "Melokalisir nyeri" },
    { id: 6, name: "Sesuai perintah" },
    { id: 0, name: "NT" }
  ];
  kesadaranLevelOpts = [
    { maxVal: 15, id: "compos mentis", text: "Compos Mentis" },
    { maxVal: 13, id: "apatis", text: "Apatis" },
    { maxVal: 11, id: "delirium", text: "Delirium" },
    { maxVal: 9, id: "somnolen", text: "Somnolen" },
    { maxVal: 6, id: "sopor", text: "Sopor" },
    { maxVal: 4, id: "semi-coma", text: "Semi Coma" },
    { maxVal: 3, id: "coma", text: "Coma" }
  ];

  formatDate(date: any) {
    if (!date) return "-";
    return moment(date).format("DD-MM-YYYY HH:mm");
  }

  get listUnitRanap() {
    return storeReferensiUnit.unit;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  get storeUser() {
    return userModule.user;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get rm() {
    return storePasien.identitasPasien?.rm;
  }

  get registerId() {
    return this.register;
  }

  get dialog(): boolean {
    return this.open;
  }

  set dialog(val: boolean) {
    this.$emit("close");
  }

  get namaUnitAsal() {
    return this.listUnitRanap.find(unit => unit.id === this.fromUnitId)?.nama;
  }

  set gcs(val: KesadaranGCS) {
    this.gcsEye = typeof val?.e == "number" ? Number(val.e) : null;
    this.gcsVerbal = typeof val?.v == "number" ? Number(val.v) : null;
    this.gcsMotor = typeof val?.m == "number" ? Number(val.m) : null;
  }

  get gcs(): KesadaranGCS {
    return {
      e: this.gcsEye,
      v: this.gcsVerbal,
      m: this.gcsMotor
    };
  }

  get gcsEyeOpts() {
    return this.gcsEyeOptions.sort((a, b) => b.id - a.id);
  }

  get gcsVerbalOpts() {
    return this.gcsVerbalOptions.sort((a, b) => b.id - a.id);
  }

  get gcsMotorOpts() {
    return this.gcsMotorOptions.sort((a, b) => b.id - a.id);
  }

  get kesadaranLevel() {
    const gcs = this.gcsEye + this.gcsVerbal + this.gcsMotor;

    const val = this.kesadaranLevelOpts
      .sort((a, b) => a.maxVal - b.maxVal)
      .find(item => gcs <= item.maxVal);

    return val && this.gcsEye && this.gcsVerbal && this.gcsMotor ? val : null;
  }

  set tensi(val: Tensi) {
    this.sistole = val.sistole;
    this.diastole = val.diastole;
  }

  get tensi(): Tensi {
    return {
      sistole: this.sistole,
      diastole: this.diastole
    };
  }

  mounted() {
    if (!this.receivedAt && !this.transferData?.received_at) {
      this.receivedAt = new Date();
      this.toUserId = Number(userModule.user.id);
    }
  }

  @Watch("kesadaranLevel")
  changeKesadaranLevel(val) {
    this.$emit("changeKesadaran", val);
  }

  @Watch("gcs", { deep: true })
  changeGCS(val) {
    this.$emit("changeGCS", val);
  }

  @Watch("value", { deep: true })
  changeValue(val) {
    console.log("change value gcs", val);
    this.gcs = JSON.parse(JSON.stringify(val));
  }

  @Watch("transferData", { immediate: true })
  onTransferDataChanged(val: any) {
    if (val) {
      this.mapServiceDataToForm(val);
      this.currentTransferId = val.id;
    }
  }

  @Watch("selectedId", { immediate: true })
  async onSelectedIdChanged(newValue: number) {
    if (this.transferData) return;

    if (newValue == null) {
      this.resetForm();
    } else {
      await this.loadExistingTransfer(this.selectedId);
    }
  }

  @Watch("register", { immediate: true })
  async onRegisterChanged(val: number) {
    if (!val) return;
    if (this.transferData) return;
    await this.loadExistingTransfer(this.selectedId);
  }

  setTensi(val: Tensi) {
    this.tensi = {
      sistole: !val.sistole && val.sistole != 0 ? null : Number(val.sistole),
      diastole: !val.diastole && val.diastole != 0 ? null : Number(val.diastole)
    };
  }
  setFrekNadi(val: number) {
    this.nadi = val == null ? null : Number(val);
  }

  setFrekNafas(val: number) {
    this.nafas = val == null ? null : Number(val);
  }

  setSuhu(val: number) {
    this.suhu = val == null ? null : Number(val);
  }

  @Watch("suhu")
  onSuhuChange(val: any) {
    if (!val) return;
    const str = val.toString().replace(/[^\d]/g, "");
    if (str.length === 3) {
      this.suhu = parseFloat(str.slice(0, 2) + "." + str.slice(2));
    }
    if (str.length > 3) {
      this.suhu = parseFloat(str.slice(0, 2) + "." + str.slice(2, 3));
    }
  }

  setSaturasiO2(val: number) {
    this.saturasiO2 = val == null ? null : Number(val);
  }

  async loadExistingTransfer(id: number) {
    if (!this.register) return;
    try {
      this.isLoading = true;
      const response = await ptiService.getByRegister(this.register);
      const list: PtiTransferResponseItem[] = response?.data || [];

      let selected: PtiTransferResponseItem | undefined;
      if (id != null) {
        selected = list.find((t: PtiTransferResponseItem) => t.id === id);
      } else {
        selected =
          list.find((t: PtiTransferResponseItem) => t.status === "pending") ||
          list[0];
      }
      if (selected) {
        this.currentTransferId = selected.id;
        this.loadedTransfer = selected;
        this.mapServiceDataToForm(selected);
      } else {
        this.currentTransferId = null;
        this.loadedTransfer = null;
      }
    } catch (e) {
      console.error("Gagal load transfer by register", e);
      this.currentTransferId = null;
    } finally {
      this.isLoading = false;
    }
  }

  resetForm() {
    this.gcsEye = null;
    this.gcsVerbal = null;
    this.gcsMotor = null;
    this.kesadaran = null;
    this.sistole = null;
    this.diastole = null;
    this.nadi = null;
    this.nafas = null;
    this.suhu = null;
    this.saturasiO2 = null;
    this.djj = null;
    this.bbs = null;
    this.tb = null;
    this.bbl = null;
    this.downscore = null;
    this.note = null;

    this.currentTransferId = null;
    this.loadedTransfer = null;
    this.receivedAt = null;

    this.formError = {
      receivedAt: null,
      eye: null,
      verbal: null,
      motor: null,
      tekananDarah: null,
      nadi: null,
      nafas: null,
      suhu: null,
      saturasiO2: null
    };
  }

  batal() {
    this.resetForm();
    this.$emit("cancel");
  }

  validateForm(): boolean {
    this.formError = {
      receivedAt: null,
      eye: null,
      verbal: null,
      motor: null,
      tekananDarah: null,
      nadi: null,
      nafas: null,
      suhu: null,
      saturasiO2: null
    };

    if (this.isAlreadyReceived) {
      return true;
    }

    const validations = [
      {
        field: "receivedAt",
        isValid: () => !!this.receivedAt,
        message: "Tanggal Diterima harus diisi"
      },
      {
        field: "eye",
        isValid: () => this.gcsEye != null,
        message: "GCS Eye harus diisi"
      },
      {
        field: "verbal",
        isValid: () => this.gcsVerbal != null,
        message: "GCS Verbal harus diisi"
      },
      {
        field: "motor",
        isValid: () => this.gcsMotor != null,
        message: "GCS Motor harus diisi"
      },
      {
        field: "nadi",
        isValid: () => this.nadi != null,
        message: "Frekuensi nadi harus diisi"
      },
      {
        field: "nafas",
        isValid: () => this.nafas != null,
        message: "Frekuensi nafas harus diisi"
      },
      {
        field: "suhu",
        isValid: () => this.suhu != null,
        message: "Suhu harus diisi"
      },
      {
        field: "saturasiO2",
        isValid: () => this.saturasiO2 != null,
        message: "Saturasi harus diisi"
      }
    ];

    let hasError = false;

    validations.forEach(rule => {
      if (!rule.isValid()) {
        (this.formError as any)[rule.field] = rule.message;
        hasError = true;
      }
    });

    if (hasError) {
      appModule.sendErrorAlert("Mohon lengkapi semua Data yang wajib diisi");
    }

    return !hasError;
  }

  loadedTransfer: PtiTransferResponseItem | null = null;

  get transferAktif(): PtiTransferResponseItem | null {
    return this.transferData || this.loadedTransfer;
  }

  get namaPenerima(): string {
    const rec = this.transferAktif;

    if (rec?.to_user?.nama) return rec.to_user.nama;
    if (rec?.to_user_id) return "-";

    return userModule.user?.nama || "-";
  }

  get namaPenjemput(): string | null {
    const rec = this.transferAktif;

    if (!rec?.pickup_user_id) return null;

    return rec.pickup_user?.nama || "-";
  }

  get tanggalDijemput(): string | null {
    const pickupAt = this.transferAktif?.pickup_at;

    return pickupAt ? this.formatDate(pickupAt) : null;
  }

  get isPengirimSendiri(): boolean {
    const pengirim = this.transferAktif?.from_user_id;

    return (
      pengirim != null && String(pengirim) === String(userModule.user?.id)
    );
  }

  get isPenerimaLain(): boolean {
    const penerima = this.transferAktif?.to_user_id;

    return (
      penerima != null && String(penerima) !== String(userModule.user?.id)
    );
  }

  get fieldReadonly(): boolean {
    return this.isReadonly || this.catatanOnly;
  }

  get receivedPayload(): PtiReceivedData {
    return {
      received_at: this.receivedAt
        ? moment(this.receivedAt).format("YYYY-MM-DD HH:mm:ss")
        : null,
      to_user_id: this.toUserId ? String(this.toUserId) : null,
      received_content: {
        no_kamar: this.noKamar || null,
        kelas_kamar: this.kelasKamar || null,
        klinis: {
          kesadaran: this.kesadaranLevel?.id || null,
          gcs: {
            e: typeof this.gcsEye === "number" ? this.gcsEye : null,
            v: typeof this.gcsVerbal === "number" ? this.gcsVerbal : null,
            m: typeof this.gcsMotor === "number" ? this.gcsMotor : null
          },
          sistole: this.sistole || null,
          diastole: this.diastole || null,
          nadi: this.nadi || null,
          nafas: this.nafas || null,
          suhu: this.suhu || null,
          spo2: this.saturasiO2 || null,
          djj: this.djj || null,
          downscore: this.downscore || null,
          bbl: this.bbl || null,
          bbs: this.bbs || null
        },
        note: this.note || ""
      }
    };
  }

  async kirimData() {
    const transferedAt = this.transferAktif?.transfered_at;
    if (this.receivedAt && transferedAt) {
      const received = moment(this.receivedAt);
      const transferAt = moment(transferedAt);
      if (received < transferAt) {
        this.$nextTick(() => {
          this.receivedAt = null;
          appModule.sendErrorAlert(
            "Tanggal dan jam penerimaan tidak boleh lebih awal dari waktu transfer: " +
              transferAt.format("DD-MM-YYYY HH:mm")
          );
        });
        return;
      }
    }

    if (!this.validateForm()) return;
    this.isLoading = true;
    try {
      const payload = this.receivedPayload;

      const response = await ptiService.receive(
        this.currentTransferId,
        payload
      );

      appModule.NoticeDelay("Data transfer internal berhasil disimpan");

      this.$emit("transfer-sent", response);

      await this.loadExistingTransfer(this.selectedId);

      this.resetForm;

      this.$root.$emit("reload-ranap-global");

      this.$emit("close");
    } catch (error) {
      console.error("Error submitting form:", error);
      appModule.sendErrorNotice(
        "Gagal mengirim data. Periksa koneksi atau data input."
      );
    } finally {
      this.isLoading = false;
    }
  }

  setDetail(data: any) {
    this.mapServiceDataToForm(data);
  }

  mapServiceDataToForm(selected: PtiTransferResponseItem) {
    if (!selected) return;

    if (selected.received_at) {
      this.receivedAt = moment(selected.received_at).toDate();
    } else {
      this.receivedAt = new Date();
    }

    this.noKamar = selected.received_content?.no_kamar || null;
    this.kelasKamar = selected.received_content?.kelas_kamar || null;
    this.fromUnitId = selected.from_unit_id || null;
    this.toUserId = selected.received_at
      ? selected.to_user_id
        ? Number(selected.to_user_id)
        : null
      : Number(userModule.user.id);
    this.gcsEye = null;
    this.gcsVerbal = null;
    this.gcsMotor = null;
    this.kesadaran = null;
    this.sistole = null;
    this.diastole = null;
    this.nadi = null;
    this.nafas = null;
    this.suhu = null;
    this.saturasiO2 = null;
    this.djj = null;
    this.downscore = null;
    this.bbl = null;
    this.bbs = null;
    this.tb = null;
    this.note = null;

    const receivedContent = selected.received_content;

    if (receivedContent && receivedContent.klinis) {
      const klinis = receivedContent.klinis;

      if (klinis.gcs) {
        this.gcsEye = klinis.gcs.e ?? null;
        this.gcsVerbal = klinis.gcs.v ?? null;
        this.gcsMotor = klinis.gcs.m ?? null;
      }

      this.kesadaran = klinis.kesadaran || null;
      this.sistole = klinis.sistole ?? null;
      this.diastole = klinis.diastole ?? null;
      this.nadi = klinis.nadi ?? null;
      this.nafas = klinis.nafas ?? null;
      this.suhu = klinis.suhu ?? null;
      this.saturasiO2 = klinis.spo2 ?? null;
      this.djj = klinis.djj ?? null;
      this.downscore = klinis.downscore ?? null;
      this.bbl = klinis.bbl ?? null;
      this.bbs = klinis.bbs ?? null;
      this.note = receivedContent.note || null;
    }
  }

  datetimeInput() {
    if (this.receivedAt) {
      const dtime = new Date();
      const received = moment(this.receivedAt);
      const transferedAt = this.transferAktif?.transfered_at;
      const transferAt = transferedAt ? moment(transferedAt) : null;

      if (
        transferAt &&
        received.format("YYYYMMDD") < moment(dtime).format("YYYYMMDD")
      ) {
        received
          .hour(transferAt.hour())
          .minute(transferAt.minute())
          .second(transferAt.second());
      }

      if (this.receivedAt > dtime) {
        this.$nextTick(() => {
          this.receivedAt = null;
          appModule.sendErrorAlert(
            "Tanggal dan jam tidak boleh melebihi <br/>" +
              moment().format("DD-MM-YYYY HH:mm")
          );
        });
      } else if (transferAt && received < transferAt) {
        this.$nextTick(() => {
          this.receivedAt = null;
          appModule.sendErrorAlert(
            "Tanggal dan jam penerimaan tidak boleh lebih awal dari waktu transfer: " +
              transferAt.format("DD-MM-YYYY HH:mm")
          );
        });
      }
    }
  }
}
